import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const NoVideoIcon: React.FC<TwoColorIconProps> = ({
  size = 24,
  color1 = 'white',
  color2 = 'black',
  className,
  onClick,
}) => {
  const fill = getHexColor(color1)
  const stroke = getHexColor(color2)
  return (
    <svg
      width={size}
      height={size}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1522 5.5H2.67392C2.22997 5.5 1.8042 5.6625 1.49028 5.95175C1.17636 6.241 1 6.63331 1 7.04237V14.9746C1 15.9096 1.40311 16.8063 2.12064 17.4674C2.83817 18.1286 3.81135 18.5 4.8261 18.5H16.3044C16.7483 18.5 17.1741 18.3375 17.488 18.0483C17.802 17.759 17.9783 17.3667 17.9783 16.9576V14.8408L21.5689 16.7314C21.865 16.8873 22.2287 16.8861 22.5236 16.7285C22.8185 16.5708 23 16.2803 23 15.9662V8.03396C23 7.71978 22.8185 7.42936 22.5236 7.27166C22.2287 7.11397 21.865 7.11285 21.5689 7.26873L17.9783 9.15927V9.02542C17.9783 8.09042 17.5752 7.19372 16.8577 6.53257C16.1401 5.87143 15.167 5.5 14.1522 5.5ZM16.0653 10.6607C16.065 10.6728 16.065 10.6849 16.0653 10.697V13.3032C16.065 13.3153 16.065 13.3273 16.0653 13.3394V16.7373H4.8261C4.31873 16.7373 3.83214 16.5516 3.47337 16.221C3.1146 15.8904 2.91305 15.4421 2.91305 14.9746V7.26271H14.1522C14.6596 7.26271 15.1462 7.44843 15.5049 7.779C15.8637 8.10957 16.0653 8.55792 16.0653 9.02542V10.6607ZM17.9783 12.8106V11.1895L21.087 9.55269V14.4474L17.9783 12.8106Z"
        fill={fill}
      />
      <path d="M4 3L22.7169 21.7169" stroke={stroke} strokeWidth="2.25" strokeLinecap="round" />
      <path d="M2.25 3.375L20.9669 22.0919" stroke={fill} strokeWidth="2.25" strokeLinecap="round" />
    </svg>
  )
}
